import styled from 'styled-components'

const Container = styled.div<{ contentHeight: string }>`
    display: flex;
    flex-direction: row;
    flex-wrap: no-wrap;
    justify-content: space-between;
    width: 100%;
    height: ${({ contentHeight = 'initial' }) => contentHeight};
    margin: 5px 0;
`

export default Container
